import React from 'react'
import { FormInputSelectAndNavigate } from '../../../../../../../ui/organisms'

export default {
  title: 'Can you tell us what type of commercial project this is?',
  next: 'projectInfo.projectRole',
  component: (props) => <FormInputSelectAndNavigate options={[
    'Restaurant',
    'Mulitunit Residential Building',
    'Retail, Grocery, or Shopping Mall',
    'Medical Facility, Hospital, Clinic, etc.',
    'Office Buildings',
    'Hotel, Lodging Facility',
    'School, College/University, Library, etc.',
    'Industrial Structure',
    'Sports Facility',
  ]} {...props}/>
}